import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import apiClient from '../../utils/api';
import { toast } from 'react-toastify';

function Dashboard() {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user } = useSelector((state) => state.auth);
    const isDriver = user?.roles?.includes('Driver');

    useEffect(() => {
        fetchDashboardStats();
    }, []);

    const fetchDashboardStats = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/dashboard/stats', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const data = response.data.data;

            let dashboardStats = [
                { label: 'Total Parking Spaces', value: data.total_spaces, note: 'Total Capacity' },
                { label: 'Free Slots', value: data.free_slots, note: 'Available for Parking' },
                { label: 'Assigned Parkings', value: data.assigned_parkings, note: 'With Assigned Drivers' },
                { label: 'Total Cars Parked', value: data.lifetime_parkings, note: 'Lifetime Parked Cars' },
                { label: 'Total Drivers', value: data.total_drivers, note: 'All Drivers on Duty' },
                { label: 'Total Customers', value: data.total_customers, note: 'All Customers Log' },
                { label: 'Total Incidents', value: data.total_incidents, note: 'All Incidents Logged' },
                { label: 'Feedback Received', value: data.total_feedbacks, note: 'All Feedbacks Received' },
                { label: 'Pending Pickups', value: data.pending_pickups, note: 'Awaiting Handover' },
                { label: 'Damaged Vehicles', value: data.damaged_vehicles, note: 'Reported Damage' },
                { label: 'Lost Tickets', value: data.lost_tickets, note: 'Manually Reissued' },
                { label: "Today's Income", value: `QR ${data.today_income}`, note: 'Collected Today' }
            ];

            // Add these stats only if user is not a driver
            if (!isDriver) {
                dashboardStats = [
                    ...dashboardStats,
                    { label: "Yesterday's Income", value: `QR ${data.yesterday_income}`, note: 'Previous Day' },
                    { label: 'Weekly Income', value: `QR ${data.weekly_income}`, note: 'Last 7 Days' },
                    { label: 'Monthly Income', value: `QR ${data.monthly_income}`, note: 'Current Month' }
                ];
            }

            setStats(dashboardStats);
        } catch (error) {
            console.error('Error fetching dashboard stats:', error);
            toast.error('Failed to load dashboard statistics');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <Row className="g-3">
                    {stats.map((item, idx) => (
                        <Col md={3} key={idx}>
                            <Card className="bg-dark text-white shadow-sm h-100">
                                <Card.Body>
                                    <h6 className="mb-1">{item.label}</h6>
                                    <h3 className="my-2">{item.value}</h3>
                                    <small>{item.note}</small>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
}

export default Dashboard;